// semester_id	long	false	学期id
// sort_type	int	true	排序方式 1.综合排序 2.查看量从高到低 3.更新时间倒序 4.创建时间倒序
// classify_id	long	false	分类id
// schoolyear_id	long	false	学年id
// keyword	string	false	搜索关键字
// organ_id	long	false	机构id
export interface IHandler {
  keyword?: string
  sort_type?: Sort
}

// 排序方式 1.综合排序 2.查看量从高到低 3.更新时间倒序 4.创建时间倒序
export enum Sort {
  COMPREHENSIVE = 1,
  VIEWNUM,
  UPDATETIME,
  CREATTIME
}
